import { IResponseProcessor } from "..";

export default class ReturnsApi {
  constructor(
    private _baseUrl: string,
    private _getToken: (applicationId: string) => string,
    private _processor: IResponseProcessor
  ) {
    console.warn(
      "Deprecation Warning: The legacy 'ReturnsApi' class is in use. Please migrate to RTK Query hooks like 'useGetV4ManufacturerByRouteManufacturerIdReturnsQuery' or 'useGetV4ResellerByRouteResellerIdReturnsQuery' from the 'randmar-api-client' package as outlined in CONTRIBUTING.md."
    );
  }

  async retrieveReturns(applicationId: string): Promise<IReturn[]> {
    const res = await fetch(
      `${this._baseUrl}/${applicationId}/Returns`, {
      headers: { Authorization: `Bearer ${this._getToken(applicationId)}` }
    });

    this._processor.process(res);

    const info: IReturn[] = await res.json();

    return info;
  }
}

/** @deprecated This is a legacy type. For new development, use the `Return` type from the `randmar-api-client` package. */
export interface IReturn {
  // Return Header
  Comments: string;
  ContactEmail: string;
  ContactName: string;
  ContactPhone: string;
  CreditNumber: string;
  InvoiceNumber: string;
  RequestDate: string;
  ResellerId: number;
  ResellerName: string;
  ReturnNumber: string;
  Status: string;
  WarehouseLocation: string;

  // Return Line Item
  Quantity: number;
  RandmarSKU: string;
  ReasonForReturn: string;
  SerialNumbers: string;

  // Denormalized Product Information
  AutoUpdate: boolean;
  Category: string;
  CreatedBy: string;
  ManufacturerName: string;
  MasterCarton: number;
  MPN: string;
  ProductType: string;
  SerialNumber: boolean;
  SkidQuantity: number;
  Title: string;
  TransparencyCode: boolean;
  UPC: string;
  UnitWeight: string;

  // Redundant fields from a legacy system.
  RandmarSKU1: string;
  ReturnNumber1: string;
}
